import React, { Component } from 'react';
import store from 'store';
import { Heading } from '../Heading/Heading';
import { bright } from '../../colors';
import { PreviewImage } from '../PreviewImage';
import {
  minWidth,
  tablet,
  desktopMedium,
  desktopLarge,
} from '../../screenSizes';
import { smallMargin, mediumMargin } from '../../margins';
import { Html } from '../Html';
import { text, h3, h4, h2 } from '../../fontSizes';
import { Button } from '../Button';

const seconds = 1000;
const days = 86400 * seconds;

export class Popup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      closeable: false,
    };
  }

  closePopup() {
    document.body.style.height = this.originalHeight;
    document.body.style.overflow = this.originalOverflow;
    this.setState({
      open: false,
    });
    this.markPopupAsShown();
  }

  openPopup() {
    this.originalHeight = document.body.style.height;
    this.originalOverflow = document.body.style.overflow;
    document.body.style.height = '100vh';
    document.body.style.overflow = 'hidden';
    this.setState({
      open: true,
    });
    setTimeout(() => {
      this.setState({ closeable: true });
    }, 500);
  }

  startPopupTimer() {
    setTimeout(() => {
      this.openPopup();
    }, this.props.popup.delay * seconds);
  }

  popupKey() {
    return `popup-${this.props.id}-${this.props.lastModified}`;
  }

  markPopupAsShown() {
    store.set(this.popupKey(), new Date().toISOString());
  }

  canShowPopup() {
    const stored = store.get(this.popupKey());
    if (!stored) {
      return true;
    }

    return new Date() - new Date(stored) > 1 * days;
  }

  componentDidMount() {
    if (this.canShowPopup()) {
      this.startPopupTimer();
    }
  }

  render() {
    const {
      id,
      heading,
      bigImage,
      content,
      popup: { callToAction: callToActionLinkPostId },
      allPosts,
    } = this.props;

    const callToActionButton =
      callToActionLinkPostId &&
      allPosts
        .filter((post) => post.id === callToActionLinkPostId)
        .map(({ slug, heading }) => ({
          href: slug,
          text: heading,
        }))[0];

    return (
      this.state.open && (
        <div
          onClick={() => this.state.closeable && this.closePopup()}
          css={`
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0, 0, 0, 0.5);
            z-index: 4;

            display: flex;
            justify-content: center;
            align-items: center;
          `}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            aria-labelledby={`popup-${id}title`}
            aria-describedby={`popup-${id}description`}
            role="dialog"
            css={`
              width: 90vw;
              position: relative;
              background: ${bright};

              ${minWidth(tablet)} {
                width: 70vw;
              }

              ${minWidth(desktopMedium)} {
                width: 600px;
              }
            `}
          >
            <div
              css={`
                width: 100%;
                max-height: 90vh;
                overflow: hidden;
                flex: 0 1 auto;
                background-color: #000;
              `}
            >
              {bigImage && (
                <div
                  css={`
                    position: absolute;
                    top: 0;
                    width: 100%;
                    z-index: 4;
                  `}
                >
                  <PreviewImage
                    src={bigImage.url}
                    alt={bigImage.alt}
                    cloudinaryOptions={{
                      extra: 'b_black,o_80',
                      ...bigImage.cloudinary,
                    }}
                    aspectRatio={bigImage.aspectRatio}
                    preview={'transparent'}
                  />
                </div>
              )}
              <div
                css={`
                  position: relative;
                  z-index: 5;
                  margin-top: ${mediumMargin};
                  padding: 0 10%;
                `}
              >
                <Heading
                  css={`
                    color: white;
                    margin-bottom: ${smallMargin};
                    font-size: ${h3};

                    &:after {
                      display: none;
                    }

                    ${minWidth(tablet)} {
                      font-size: ${h2};
                    }
                  `}
                >
                  {heading}
                </Heading>
                {content && content.length && (
                  <Html
                    css={`
                      color: white;
                      line-height: initial;
                      font-size: ${text};
                      padding-bottom: ${smallMargin};
                      min-height: 0;

                      ${minWidth(tablet)} {
                        font-size: ${h4};
                      }

                      ${minWidth(desktopLarge)} {
                        font-size: ${h3};
                      }
                    `}
                    html={content}
                  />
                )}
              </div>
              {callToActionButton && (
                <div
                  css={`
                    position: absolute;
                    bottom: ${mediumMargin};
                    left: 0;
                    width: 100%
                    display: flex;
                    justify-content: center;
                  `}
                >
                  <Button
                    css={`
                      font-weight: 400;
                    `}
                    primary
                    onClick={() => this.closePopup()}
                    href={callToActionButton.href}
                  >
                    {callToActionButton.text}
                  </Button>
                </div>
              )}
            </div>
            <Button
              onClick={() => this.closePopup()}
              bright
              noBorder
              aria-label="stäng"
              css={`
                position: absolute;
                top: 0;
                right: 0;
                padding: 5px;
                font-weight: 400;
                transform: translateY(-100%);

                &:hover {
                  background: transparent;
                }

                ${minWidth(tablet)} {
                  transform: none;
                }
              `}
            >
              X
            </Button>
          </div>
        </div>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/PopupSection/Popup.js